import "core-js/modules/es.array.index-of";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import Vue from 'vue';
import { mapState } from 'vuex';
import atom from '@tencent/vft-atom';
import env from '@tencent/vft-common/env';
import weixin from '@tencent/vft-common/weixin';
import accountCheck from '@tencent/vft-common/openapp/openapp-account-check';
import { loginService, userService, vipService } from '@vip-activity/business';
import util from '@tencent/vft-common/util';
import { buildUrl } from '@tencent/vft-common/url';
import { defaultAvatar } from '@vip-activity/ui/components/Avatar/Avatar.vue';
import { parseTemplate, removeHttp } from '@/util/helper';
import reportData from '../config/reportData';
var shield = null;
Vue.mixin({
  data: function data() {
    return {
      reportData: reportData,
      page: util.getUrlParam('page'),
      uid: util.getUrlParam('uid'),
      oid: util.getUrlParam('oid'),
      loginService: loginService,
      userService: userService,
      vipService: vipService,
      defaultAvatar: defaultAvatar,
      accountCheck: accountCheck
    };
  },
  filters: {
    removeHttp: removeHttp,
    hideNick: util.hideNick,
    formatNum: util.formatNum
  },
  computed: _objectSpread(_objectSpread({}, mapState(['hasTickets', 'buyList', 'now'])), {}, {
    isSelf: function isSelf() {
      if (!this.loginService.isLogin) return false;
      return +this.uid === +this.userService.vuid;
    },
    userAvatar: function userAvatar() {
      return this.userService && this.userService.headurl || defaultAvatar;
    }
  }),
  methods: {
    initShareInfo: function initShareInfo() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          分享朋友圈标题 = _ref.分享朋友圈标题,
          分享图 = _ref.分享图,
          分享链接 = _ref.分享链接,
          分享标题 = _ref.分享标题,
          分享描述 = _ref.分享描述;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var shareObj = {
        timeLineTitle: parseTemplate(分享朋友圈标题, data),
        imgUrl: 分享图,
        title: parseTemplate(分享标题, data),
        desc: parseTemplate(分享描述, data),
        link: 分享链接 || window.location.href
      };
      setTimeout(function () {
        weixin.setAllShare(shareObj);
      }, 500);
    },
    openPay: function openPay() {
      var checkTicket = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.loginService.isLogin) {
        this.loginService.openLogin();
        return;
      }

      if (!checkTicket) {
        this.eventBus.$emit('showPayPop');
        return;
      }

      if (!this.hasTicket) {
        this.eventBus.$emit('showPayPop');
      }
    },
    shieldRun: function shieldRun(secInfo, callback, errCallBack) {
      shield = shield || new VftShield(); // eslint-disable-line

      shield.setStrategy(secInfo); // conifg具有类似该结构{iRet: xxx, sAppId: yyy}

      shield.run().then(function () {
        // 验证成功
        callback && callback(); // eslint-disable-line
      }, function (e) {
        errCallBack && errCallBack(e); // eslint-disable-line

        console.log(e);
      });
    },
    $openLogin: function $openLogin() {
      this.loginService.openLogin();
    },
    loginTips: function loginTips() {
      var _this = this;

      this.confirm({
        msg: '当前登录态已过期，请重新登录',
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _this.$openLogin();
        }
      });
    },
    isSchema: function isSchema() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return url.match(/^(txvideo|tenvideo2)/);
    },
    openUrl: function openUrl(url) {
      if (!url) {
        return;
      }

      if (this.isSchema(url)) {
        accountCheck.openApp(url, true);
      } else if (env.isApp) {
        var subUrl = url.indexOf('//') === 0 ? window.location.protocol + url : url;
        atom.invoke('openView', {
          url: "txvideo://v.qq.com/HollywoodH5Activity?url=".concat(encodeURIComponent(subUrl))
        });
      } else {
        window.location.href = url;
      }
    },
    openProperty: function openProperty() {
      this.openUrl('//film.qq.com/weixin/v3/asset/index.html?header=0#award');
    },
    openVip: function openVip() {
      if (!this.loginService.isLogin) {
        this.$openLogin();
        return;
      }

      var isTv = !!util.getUrlParam('fromtv');
      var _window$setting$$ = window.setting.支付面板.引导文案,
          SVIP开通链接 = _window$setting$$.SVIP开通链接,
          会员开通链接 = _window$setting$$.会员开通链接;
      var curUrl = window.location.href;
      var url = buildUrl(isTv ? SVIP开通链接 : 会员开通链接, {
        ru: encodeURIComponent(curUrl)
      }); // 如果开通链接没有ptag，则设置活动页的ptag

      if (!util.getUrlParam('ptag', SVIP开通链接)) {
        url = util.setUrlParam('ptag', util.getUrlParam('ptag'), url);
      }

      this.openUrl(url);
    },
    openKefu: function openKefu() {
      this.openUrl('//kf.qq.com/touch/video/index.html');
    }
  }
});